export const getLimitText = (limit: number, text: string | null) => {
  if (text !== null && text.length > limit) {
    const limitText = text.substring(0, limit);
    return `${limitText} ...`;
  } else {
    return text;
  }
};
